/*
  Lazy video loader.
  Markup: <video data-lazy-video data-autoplay muted loop playsinline preload="none">
            <source data-src="..." type="video/mp4">
          </video>
  (or data-src directly on the <video>). The file is only requested once the
  video is near the viewport; data-autoplay videos play while visible and
  pause when scrolled away. Hidden videos (display:none) never load.
*/
(function () {
  var videos = document.querySelectorAll('video[data-lazy-video]');
  if (!videos.length) return;

  function load(video) {
    if (video.hasAttribute('data-lazy-loaded')) return;
    video.setAttribute('data-lazy-loaded', '');
    if (video.dataset.src) video.setAttribute('src', video.dataset.src);
    video.querySelectorAll('source[data-src]').forEach(function (source) {
      source.setAttribute('src', source.dataset.src);
    });
    video.preload = 'auto';
    video.load();
  }

  function play(video) {
    if (!video.hasAttribute('data-autoplay')) return;
    var promise = video.play();
    if (promise && promise.catch) promise.catch(function () {});
  }

  if (!('IntersectionObserver' in window)) {
    videos.forEach(function (video) {
      load(video);
      play(video);
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          load(video);
          play(video);
        } else if (video.hasAttribute('data-lazy-loaded') && video.hasAttribute('data-autoplay')) {
          video.pause();
        }
      });
    },
    { rootMargin: '300px 0px' }
  );

  videos.forEach(function (video) {
    observer.observe(video);
  });
})();
